import React from 'react';
import classNames from 'classnames';
import { bool, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Icon } from '@fiverr-private/fit';
import { r_chevron_down } from '@fiverr-private/icons';
import dynamicTranslations from '../../../../../utils/translation/DynamicTranslationService';

const Trigger = ({ isOpen, selected, onClick }) => (
    <div className="industries-filter-trigger" onClick={onClick}>
        {selected ? dynamicTranslations.getIndustryTranslation(selected) : <I18n k="reviews.filters.all_industry" />}
        <Icon className={classNames('industry-filter-collapse', { 'industry-dropdown-opened': isOpen })} size={11}>
            {r_chevron_down}
        </Icon>
    </div>
);

Trigger.propTypes = {
    isOpen: bool,
    selected: string,
};

export default Trigger;
